import SelectComponent from "@via/components/select/select.tsx";
import { AwsRegions, USER_ROLES } from "@via/utils/constants.tsx";
import { credentialOptions } from "@via/utils/form-validators.tsx";
import { JSX } from "react";

export default function AmazonCredentialsForm({
  role,
  register,
  control,
  errors,
}): JSX.Element {
  return (
    <>
      <div className="space-y-4 pb-5">
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Credential Name <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              data-testid="awsNameInput"
              {...register(
                "amazonCredentials.name",
                credentialOptions.amazonCredentials.name
              )}
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Enter Your Credential Name"
            />
            {errors.amazonCredentials?.name && (
              <span className="text-xs text-rose-500">
                {errors.amazonCredentials.name.message}
              </span>
            )}
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Amazon Access Key <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              data-testid="awsAccessKeyInput"
              {...register(
                "amazonCredentials.amzAccKey",
                credentialOptions.amazonCredentials.amzAccKey
              )}
              type="text"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder="Enter Your Access Key"
            />
            {errors.amazonCredentials?.amzAccKey && (
              <span className="text-xs text-rose-500">
                {errors.amazonCredentials.amzAccKey.message}
              </span>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Amazon Secret Key <span className="text-red-400">*</span>
          </label>
          <div className="mt-2">
            <input
              {...register(
                "amazonCredentials.amzSucKey",
                credentialOptions.amazonCredentials.amzSucKey
              )}
              data-testid="awsSecretKeyInput"
              type="password"
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            {errors.amazonCredentials?.amzSucKey && (
              <span className="text-xs text-rose-500">
                {errors.amazonCredentials.amzSucKey.message}
              </span>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Default Region <span className="text-red-400">*</span>
          </label>
          <div className="mt-2" data-testid="awsRegionSelector">
            <SelectComponent
              control={control}
              name="amazonCredentials.amzDefReg"
              placeholder="Choose a Region"
              rules={credentialOptions.amazonCredentials?.amzDefReg}
              options={AwsRegions}
              enableClear={false}
            />
          </div>
        </div>
        {role === USER_ROLES.ADMIN && (
          <label className="flex items-center text-sm font-medium leading-6 text-gray-900">
            <input
              data-testid="awsHideUserSelector"
              {...register("amazonCredentials.hide")}
              type="checkbox"
              className="mr-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
            />
            Hide Amazon Keys from User
          </label>
        )}
      </div>
    </>
  );
}
